<template>
  <div class="layout">
    <mainHeader></mainHeader>
    <router-view />
  </div>
</template>

<script>
import mainHeader from "@/components/mainHeader.vue";
export default {
  components: {
    mainHeader,
  },
};
</script>

<style>
</style>